import React from 'react'
import { useField } from 'formik'
import { KeyboardTimePicker } from '@material-ui/pickers'

const FormikTimePicker = ({ name, variant, ...props }) => {
  const [field, meta] = useField({ name })
  const { touched, error } = meta
  const { onChange, ...fieldRest } = field
  const hasError = Boolean(touched && error)

  const handleChange = date =>
    onChange({
      target: {
        name,
        value: date,
      },
    })

  return (
    <KeyboardTimePicker
      {...fieldRest}
      {...props}
      clearable
      ampm={false}
      inputVariant={variant}
      onChange={handleChange}
      error={hasError}
      helperText={hasError ? error : null}
    />
  )
}

FormikTimePicker.defaultProps = {
  variant: 'filled',
}

export default FormikTimePicker
